import { Button, ButtonPropTypes } from "./Button";
import * as Icons from "icons";
import { useTheme } from "context/ThemeContext";
import { lightenColor } from "utils/colors.utils";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

const IconButton = (props) => {
  const { style, disabled, title, iconName, tooltipPlacement, ...resProps } =
    props;

  const { theme } = useTheme();
  const bgColor = lightenColor(theme.primaryColor, 0.85);
  const secondaryStyle = {
    backgroundColor: bgColor,
    color: theme.primaryColor,
    minWidth: 30,
    width: 30,
    Height: 30,
    transition: "border-radius 0.3s ease-in-out",
    ...style,
  };

  const Icon = Icons[iconName];
  if (!Icon) {
    console.error(`Icon ${iconName} not found in icons module.`);
    return null;
  }
  return (
    <Button
      {...resProps}
      style={secondaryStyle}
      className="p-0 flex justify-center items-center"
      disabled={disabled}
      onMouseOver={(e) => {
        e.currentTarget.style.borderRadius = "50%";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderRadius = "0.375rem";
      }}
    >
      <Tooltip
        title={title || ""}
        arrow={false}
        placement={tooltipPlacement}
        componentsProps={{
          popper: {
            style: { margin: 0 },
          },
        }}
      >
        <div
          className="flex justify-center items-center"
          style={{ height: 30, width: 30 }}
        >
          <Icon fill={theme.primaryColor} width={15} height={15} />
        </div>
      </Tooltip>
    </Button>
  );
};

IconButton.propTypes = {
  ...ButtonPropTypes,
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  tooltipPlacement: PropTypes.string,
};

export default IconButton;
